import { Navigate, type RouteObject } from 'react-router-dom';

import { AcceptInvite } from './AcceptInvite';
import { Login } from './Login';

// No signup route: accounts are created by a platform admin or by accepting
// an invitation. Tenant users never self-register.
export const authRoutes: RouteObject[] = [
  { path: 'login', element: <Login /> },
  { path: 'accept-invite/:token', element: <AcceptInvite /> },
  { path: '', element: <Navigate to="login" replace /> },
  { path: '*', element: <Navigate to="login" replace /> },
];
